import { useMemo } from 'react';

import {
  useEntitySchema,
  useRouteAndQueryParams,
} from '@april9au/stack9-react';
import { ep, ern } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import CountrySetupForm from './CountrySetupForm';
import PriceRuleInfo from './PriceRuleInfo';
import PromoCodeInfo from './PromoCodeInfo';
import ReferenceData from './ReferenceData';

const S9CustomEntityFormPage = ui.S9CustomEntityFormPage.default;
const S9Tabs = ui.S9Tabs.default;

const CountrySetupDetail = () => {
  const { schema } = useEntitySchema(entityNames.COUNTRY_SETUP);

  const {
    routeParams: { id = '' },
  } = useRouteAndQueryParams();

  const countrySetupId = ern(+ep(id));

  const items = useMemo(
    () => [
      {
        label: 'Details',
        key: 'details',
        children: <CountrySetupForm schema={schema} />,
      },
      {
        label: 'Pricing',
        key: 'pricing',
        children: (
          <>
            <PriceRuleInfo
              countrySetupId={countrySetupId}
              initialValues={{ country_setup_id: countrySetupId }}
            />
            <PromoCodeInfo
              countrySetupId={countrySetupId}
              initialValues={{ country_setup_id: countrySetupId }}
            />
          </>
        ),
      },
      {
        label: 'Reference data',
        key: 'reference_data',
        children: <ReferenceData countrySetupId={countrySetupId} />,
      },
    ],
    [countrySetupId, schema],
  );

  return (
    <S9CustomEntityFormPage
      entityKey={entityNames.COUNTRY_SETUP}
      screenQueryName={EDetailsQueryNames.GetCountrySetupDetails}
      entityId={countrySetupId}
      title={data => `Country setup #${data?.id}`}
      cancelLink={AppRoutes.CountrySetupList}
      syncFieldsOnRefetch
    >
      <S9Tabs items={items} />
    </S9CustomEntityFormPage>
  );
};
export default CountrySetupDetail;
